module.exports = __webpack_public_path__ + "img/aanleg6.35beaa45.jpg";